import { useState } from 'react'
import { lumi } from '@/lib/lumi'

export const useVehicles = () => {
  const [vehicles, setVehicles] = useState<any[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const fetchVehicles = async (options?: {
    filter?: Record<string, any>
    sort?: Record<string, 1 | -1>
    limit?: number
    skip?: number
  }) => {
    setLoading(true)
    try {
      const { list, total } = await lumi.entities.vehicles.list(options || {})
      setVehicles(list)
      setTotal(total)
    } catch (error) {
      console.error('Fetch vehicles failed:', error)
    } finally {
      setLoading(false)
    }
  }

  const createVehicle = async (data: any) => {
    const newVehicle = await lumi.entities.vehicles.create(data)
    await fetchVehicles()
    return newVehicle
  }

  const updateVehicle = async (id: string, updates: any) => {
    if (typeof id !== 'string') {
      throw new Error('ID must be a string')
    }
    const updated = await lumi.entities.vehicles.update(id, updates)
    await fetchVehicles()
    return updated
  }

  const deleteVehicle = async (id: string) => {
    if (typeof id !== 'string') {
      throw new Error('Invalid ID: must be a string')
    }
    await lumi.entities.vehicles.delete(id)
    await fetchVehicles()
  }

  return {
    vehicles,
    total,
    loading,
    fetchVehicles,
    createVehicle,
    updateVehicle,
    deleteVehicle,
  }
}
